import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../../common/DisplayData/DisplayData";
import ActionBar from "../../../common/ActionBar/ActionBar";
import { BlockIcon, ActivateIcon } from "../../../common/Icons";
import { Button } from "../../../common/VFX-UI";

//App
import { LookupTypeContext } from "./LookupTypeContainer";
import useComponentGeneralStyles from "../../../styles";
import { EMPTY_GUID } from "../../../../utility/constants";
import { LookupTypeViewProps } from "../../../../types/lookupType";

const LookupTypeView = (props: LookupTypeViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
  } = props;
  const lookupTypeContext = useContext(LookupTypeContext);
  const generalStyles = useComponentGeneralStyles();

  const lookupType = lookupTypeContext?.data;

  return (
    <FormBackGround>
      <FormHeader
        title="View Lookup Type"
        chipLabel={lookupType?.isActive ? "Active" : "Inactive"}
        onClose={onClose}
        editActionHandler={editAction}
      />
      <>
        <DisplayData text="Name" importedData={lookupType?.name}></DisplayData>
        <DisplayData
          text="Description"
          importedData={lookupType?.description}
        ></DisplayData>
        <DisplayData
          text="Grouped"
          importedData={lookupType?.isGrouped ? "Yes" : "No"}
        ></DisplayData>
        {lookupType?.id &&
          lookupType?.id !== EMPTY_GUID &&
          lookupType?.isActive && (
            <Container>
              <Button
                style={generalStyles.deleteButton}
                onClick={toggleDeactivateHandler}
              >
                <BlockIcon />
              </Button>
            </Container>
          )}
        {lookupType?.id &&
          lookupType?.id !== EMPTY_GUID &&
          !lookupType?.isActive && (
            <Container>
              <Button
                style={generalStyles.activateButton}
                onClick={toggleActivateHandler}
              >
                <ActivateIcon />
              </Button>
            </Container>
          )}
      </>
      <Container style={generalStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default LookupTypeView;
